import chatbotRequest from '@/service/channel/http'
import type { HandoverReq, HandoverRes } from '../type/handover'

export function handoverApi(data: HandoverReq): Promise<HandoverRes> {
    return chatbotRequest<HandoverRes, HandoverReq, HandoverRes>({
        url: '/api/room/handover',
        method: 'post',
        data,
    })
}